import React, {Component} from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { PieChart } from 'react-minimal-pie-chart';

import axios from 'axios';
import LoadingScreen from './common/loading-screen'
import { Accordion, Card } from "react-bootstrap";

import Header from './Header';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faSearch, faListOl,faSquare, faExclamation, faChevronRight, faCartArrowDown, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons'
import { Tabs, Tab } from "react-bootstrap";
import _ from 'lodash';

import {MAP_COUNTRYCODES, GLOBALAPIHEADER } from './../constants/index';
import { getDiff, isRankUp, getDifferenceInDays} from './helper';

import '../css/style.css';
import '../css/leaderboard.css';
import reactDom from 'react-dom';

var today = new Date();
var firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

class LeaderBoard extends Component {
    constructor(props) {
        super(props);
       
        this.state = {
            showLeaderBoard            : false,
            startDate                  : firstDateOfMonth,
            endDate                    : today,
            searchInput                : "",
            data                       : [],
            filteredData               : [],
            employeeData               : [],
            country                    : [],
            countryData                : [],
            countryFilteredData        : [],
            global                     : [],
            globalData                 : [],
            globalFilteredData         : [],
            filterCountry              : [],
            countryHeartist            : [],
            countryHeartistFilteredData: [],
            countryHeartistLoad        : 10,
            isHeartistLoaded           : false,
            countryHeartistEndOfList   : false,
            fetchingCountryHeartistData: true,
            globalHeartist             : [],
            globalHeartistFilteredData : [],
            globalHeartistLoad         : 10,
            globalHeartistEndOfList    : false,
            countrySearch              : '',
            countryHeartistSearch      : '',
            showGlobalError            : false,
            selected                   : '',
            hotelDetails               : [],
            fetchingData               : true,
            fetchingDashboardData      : true,
            dashboardData              : [],
            activeDropDown             : 'monthly',
            employeeEndOfList          : false,
            countryEndOfList           : false,
            globalEndOfList            : false,
            fetchingEmployeeData       : false,
            fetchingCountryData        : false,
            fetchingGlobalData         : false,
            employeePage               : 1,
            countryPage                : 1,
            globalPage                 : 1,
            rank                       : {},
            previousStart              : '',
            previousEnd                : ''     
        };

    }

    componentWillMount = () => {
        if(!this.props.location.state){
             window.location.href = "/";
        }else if(!this.props.location.state.hotelCode){
            window.location.href = "/";
        }
    }

    componentDidMount() {
        const {startDate, endDate, activeDropDown} = this.state;
        const {hotelCode} = this.props.location.state;
        let fetchEmployee, fetchGlobal, fetchDashboard;
        if(sessionStorage.getItem('hotelDetails')){
            const rid_code = JSON.parse(sessionStorage.getItem('hotelDetails')).rid_code;
            const hotelCode = JSON.parse(localStorage.getItem('hotelData')).HotelCode;
            if( rid_code !== hotelCode){
                sessionStorage.removeItem('hotelDetails');
                sessionStorage.removeItem('dashboardData'); //TAB 1
                sessionStorage.removeItem('employeeData');  //TAB 2
                sessionStorage.removeItem('data');
                sessionStorage.removeItem('globalData');    //TAB 4
                sessionStorage.removeItem('global');
                sessionStorage.removeItem('countryData');   //TAB 3
                sessionStorage.removeItem('country');
                fetchDashboard = this.getDashboardData(activeDropDown);
            } else {
                this.setState({
                    hotelDetails  : JSON.parse(sessionStorage.getItem('hotelDetails')),
                });
            }
        }else{
            fetchDashboard = this.getDashboardData(activeDropDown);
        }

        // DASHBOARD DATA
        if(sessionStorage.getItem('dashboardData')){
            this.setState({
                dashboardData : JSON.parse(sessionStorage.getItem('dashboardData')),
                fetchingDashboardData : false
            });
            this.getRankingTiles(JSON.parse(sessionStorage.getItem('dashboardData')));
        }else{
            fetchDashboard = this.getDashboardData(activeDropDown);
        }      
        // DASHBOARD DATA     

        // HOTEL DATA
        if(sessionStorage.getItem('employeeData')){
            this.setState({
                employeeData : JSON.parse(sessionStorage.getItem('employeeData')), 
                data: JSON.parse(sessionStorage.getItem('data'))});
        }else{
            fetchEmployee = this.getEmployeeData(startDate, endDate, hotelCode);
        }
        // END HOTEL DATA


        // GLOBAL_DATA 
        if(sessionStorage.getItem('globalData')){
            this.setState({
                globalData : JSON.parse(sessionStorage.getItem('globalData')),
                global: JSON.parse(sessionStorage.getItem('global')),
                globalHeartist: JSON.parse(sessionStorage.getItem('globalHeartist')),
            });
            this.filterCountries(JSON.parse(sessionStorage.getItem('globalData')));
        }else{
            fetchGlobal = this.getGlobalData(startDate, endDate);
        }
        //END GLOBAL_DATA

        Promise.all([fetchEmployee, fetchGlobal, fetchDashboard]).then(() =>{
            if(sessionStorage.getItem('countryData')){
                this.setState({
                    countryData : JSON.parse(sessionStorage.getItem('countryData')),
                    country : JSON.parse(sessionStorage.getItem('country')),
                    countryHeartist: JSON.parse(sessionStorage.getItem('countryHeartist')),                    
                    fetchingData : false
                });
            }else{
                 this.getCountryData(startDate, endDate);
                 this.setState({fetchingData : false});
            }
            if(sessionStorage.getItem('countryEmployeeData')){
                this.setState({
                    countryEmployeeData : JSON.parse(sessionStorage.getItem('countryEmployeeData')),
                });
            }else{
                this.getCountryEmployeeData(startDate, endDate);
            }
        });
    }

    getRankingTiles(result){
        if(result.countryRank && result.pre_countryRank && result.globalRank && result.pre_globalRank){
            var rank={
                'countryRank'   : getDiff(result.countryRank['rank'], result.pre_countryRank['rank']),
                'countryRankUp' : isRankUp(result.countryRank['rank'], result.pre_countryRank['rank']),
                'globalRank'    : getDiff(result.globalRank['rank'], result.pre_globalRank['rank']),
                'globalRankUp'  : isRankUp(result.globalRank['rank'], result.pre_globalRank['rank']),
                'sales'         : getDiff(result.sales['total'], result.pre_countryRank['total'], 'sales'),
                'salesUp'       : isRankUp(result.sales['total'], result.pre_countryRank['total'],'sales')
            };
            this.setState({ rank : rank});
        }
    }

    getUrl=()=>{ 
        var urlPath = window.location.href;
        if(urlPath.indexOf("localhost") !== -1) {
            return {
                // apiURL : "https://api-uat.accorplus.com/v1/"
                apiURL : "https://int-api.accorplus.com/v1/"
            };
        } else if(window.location.host.indexOf("dev-hotelsales") !== -1) {
            return {
                // apiURL : "https://api-uat.accorplus.com/v1/"
                apiURL : "https://int-api.accorplus.com/v1/"
            };
        } else {
            return {
                apiURL : "https://int-api.accorplus.com/v1/"
            };
        }
    }

    handleTypeChange = (event) =>{ 
        const type =  event.target.value ?? 'monthly';
        this.setState({
            activeDropDown : type,
            fetchingDashboardData : true});
        this.getDashboardData(type);
    }

    getDashboardData = async (type) => {
        const {startDate, endDate} = this.state;
        const {hotelCode} = this.props.location.state;
        const start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        
        const dateDiff = getDifferenceInDays(new Date(startDate), new Date(endDate));
        const preDate = new Date(startDate);
        const preGmtDate = preDate.setDate(preDate.getDate() - dateDiff);
        const previousStart = moment(startDate).subtract(dateDiff+1, 'days').startOf("day").format("DD/MM/YYYY");
        const previousEnd = moment(new Date(preGmtDate)).add(dateDiff-1, 'days').startOf("day").format("DD/MM/YYYY");

        this.setState({ 
            previousStart : previousStart,
            previousEnd : previousEnd
        });
    
        await this.getHotelDetails(startDate, endDate, hotelCode);
        const subsidiary =  this.state.hotelDetails ?  this.state.hotelDetails.subsidiary : "";
        let url = `${this.getUrl().apiURL+'leaderboarddashboard?ridCode='+hotelCode}`;
        if(subsidiary){
           url = url + `${'&subsidiary='+subsidiary}`
        }
        // if(type){
        //     url = url + `${'&type='+type}`;
        // }else{
            url = url + `${'&start_date='+start+'&end_date='+end+'&previous_start_date='+previousStart+'&previous_end_date='+previousEnd}`;
        //}
        await axios.get(url, GLOBALAPIHEADER)
            .then(response => {
                if (response.status === 200) {
                    if(response.data) {
                        let result = response.data;
                        // console.log('DASHBOARD_DATA', result)
                        this.setState({ 
                            dashboardData : result, //DASHBOARD_DATA dashboardData
                            fetchingDashboardData : false
                        });
                        sessionStorage.setItem('dashboardData',JSON.stringify(result));
                        this.getRankingTiles(result);
                    }
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ showGlobalError : true , fetchingDashboardData : false });  
        });
    }

    getHotelDetails = async (startDate, endDate, ridCode) => {
        let start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        
        await axios.get(`${this.getUrl().apiURL+'vendor?start_date='+start+'&end_date='+end+'&page=1&ridCode='+ridCode}`, GLOBALAPIHEADER)
            .then(response => {
                if (response.status === 200) {
                    // console.log('hotelDetails', response)
                    if(response.data && response.data.length > 0){
                        this.setState({ 
                            hotelDetails: response.data['0']});
                            sessionStorage.setItem('hotelDetails',JSON.stringify(response.data['0']));
                        return;
                    }
                    this.setState({fetchingData : false }); 
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ showGlobalError : true , fetchingData : false}); 
                return;
        });
    }

    getEmployeeData = async (startDate, endDate, ridCode, updatePage=false) => {
        let start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        let page =  1;
        if(updatePage){
            page = this.state.employeePage + 1;
            this.setState({employeePage : page});
        }
        
        let index = 1;
        if(page !== "1"){
            index = ((page - 1) * 10) + 1;
            this.setState({fetchingEmployeeData : true});
        }
        
        await axios.get(`${this.getUrl().apiURL+'employee?start_date='+start+'&end_date='+end+'&page='+page+'&ridCode='+ridCode}`, GLOBALAPIHEADER)
        // await axios.get(`${this.getUrl().apiURL+'employee?start_date='+start+'&end_date='+end+'&page='+page}`, GLOBALAPIHEADER)
            .then(response => {
                if (response.status === 200) {
                    if(response.data && Object.keys(response.data).length > 0){
                        // console.log('HOTEL_DATA', response.data)
                        if(page !== 1 && response.data.employees['0'].length === 0){
                            this.setState({
                                fetchingEmployeeData : false,
                                employeeEndOfList : true});
                        } else if(response.data.employees['0'].length > 0) {
                            let oldEmployeeData = (page === 1 ? [] : this.state.data);
                            // var sortedData = _.orderBy(response.data.employees['0'], ['unitsSold'],['desc']);
                            var sortedData = (response.data.employees['0']);
                            for(let i = 0; i < sortedData.length; i++){
                                let newData = sortedData[i];
                                newData.index = index++;
                                oldEmployeeData.push(newData); 
                            }
                            console.log('sorted-data', sortedData)
                            this.setState({
                                data                 : oldEmployeeData,
                                employeeData         : oldEmployeeData,
                                fetchingEmployeeData : false,
                                employeeEndOfList    : sortedData.length < 10 ? true : false
                            });
                            if(page === 1){
                                sessionStorage.setItem('employeeData',JSON.stringify(oldEmployeeData));
                                sessionStorage.setItem('data',JSON.stringify(oldEmployeeData));
                            }
                        }
                    }
                    
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ showGlobalError : true , fetchingData : false });  
        });
    }

    getCountryData = async (startDate, endDate, updatePage=false) => {
        let start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        const {hotelCode} = this.props.location.state;
        let page =  1;
        if(updatePage){
            page = this.state.countryPage + 1;
            this.setState({countryPage : page});
        }
        
        let index = 1;
        if(page !== "1"){
            index = ((page - 1) * 10) + 1;
            this.setState({fetchingCountryData : true});
        }
        await this.getHotelDetails(startDate, endDate, hotelCode);
        const subsidiary =  this.state.hotelDetails ?  this.state.hotelDetails.subsidiary : "";
        if(subsidiary){
            await axios.get(`${this.getUrl().apiURL+'vendor?start_date='+start+'&end_date='+end+'&page='+page+'&subsidiary='+subsidiary}`, GLOBALAPIHEADER)
            .then(response => {
                if (response.status === 200) {
                    console.log('COUNTRY_DATA', response)
                    if(page !== 1 && response.data.length === 0){
                        this.setState({countryEndOfList : true,
                            fetchingCountryData : false});
                    } else {
                        if(response.data && response.data.length > 0){
                            let oldCountryData = (page === 1 ? [] : this.state.country);
                            let countryHeartistData = [];
                            let countryData = response.data;
                            for(let i = 0; i < countryData.length; i++){ 
                                let newData = countryData[i];
                                newData.index = index++;
                                oldCountryData.push(newData); 
                                newData.employees.map((item, index) => {
                                    console.log('it', item)
                                    item.map((emp, j) => {
                                        let newEmployeeData = {
                                            "rid_code": newData.rid_code,
                                            "subsidiary": newData.subsidiary,
                                            "vendorName": newData.vendorName,
                                            "membershipBreakdown": item[j].employeeMembershipBreakdown,
                                            "salesRepName": emp.salesRepName,
                                            "unitsSold": emp.unitsSold
                                        }
                                        countryHeartistData.push(newEmployeeData)
                                    })
                                })
                            }
                            console.log('c-heart', countryHeartistData)
                            this.setState({ 
                                country             : oldCountryData,
                                countryData         : oldCountryData,
                                countryHeartist     : countryHeartistData,
                                fetchingCountryData : false,
                                fetchingData        : false,
                                fetchingCountryHeartistData : false,
                                countryEndOfList    : countryData.length < 10 ? true : false
                            });
                            if(page === 1){
                                sessionStorage.setItem('countryData',JSON.stringify(oldCountryData));
                                sessionStorage.setItem('country',JSON.stringify(oldCountryData));
                                sessionStorage.setItem('countryHeartist',JSON.stringify(countryHeartistData));
                            }
                        }
                    }
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ 
                    showGlobalError : true,
                    fetchingData    : false
                });  
            });
        }
    }

    filterCountries = (data) => {
        const uniques = _.uniq(_.map(data, 'country'));
        let filterCounrty = [];
        uniques.map((item)=>{
            filterCounrty.push(MAP_COUNTRYCODES[item])
        })
        console.log('all', filterCounrty)
        this.setState({filterCountry: filterCounrty });
    }

    getGlobalData = async (startDate, endDate, updatePage=false) => {
        let start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        let page =  1;
        if(updatePage){
            page = this.state.globalPage + 1;
            this.setState({globalPage : page});
        }
        
        let index = 1;
        if(page !== "1"){
            index = ((page - 1) * 10) + 1;
            this.setState({fetchingGlobalData : true});
        }
        await axios.get(`${this.getUrl().apiURL + 'vendor?start_date='+start+'&end_date='+end+'&page='+page}`, GLOBALAPIHEADER)
            .then(response => {
                // console.log('GLOBAL_DATA', response)
                if (response.status === 200 ) {
                    if(page !== 1 && response.data.length === 0){
                        this.setState({globalEndOfList : true,
                            globalHeartistEndOfList : true,
                            fetchingGlobalData : false});
                    } else if(response.data.length > 0) {
                        let previousData = (page === 1 ? [] : this.state.global);
                        // let previousHeartistData = (page === 1 ? [] : this.state.globalHeartist);
                        let globalData = [];
                        let globalHeartistData = [];
                        Object.entries(response.data).map((key, i) => {
                            const data = key[1];
                            globalData[i] = data;
                            globalData[i].index = index++
                            globalData[i].countryName = MAP_COUNTRYCODES[data.country]; 
                            previousData.push(globalData[i]);
                        });

                        if (!this.state.isHeartistLoaded) {
                            for(let i = 0; i < response.data.length; i++){ 
                                let newData = response.data[i];
                                newData.index = index++;
                                newData.employees.map((item, index) => {
                                    item.map((emp, j) => {
                                        let newEmployeeData = {
                                            "rid_code": newData.rid_code,
                                            "subsidiary": newData.subsidiary,
                                            "vendorName": newData.vendorName,
                                            "countryName": newData.countryName,
                                            "subsidiary": newData.subsidiary,
                                            "country": newData.country,
                                            "membershipBreakdown": item[j].employeeMembershipBreakdown,
                                            "salesRepName": emp.salesRepName,
                                            "unitsSold": emp.unitsSold
                                        }
                                        globalHeartistData.push(newEmployeeData)
                                    })
                                })
                            }
                            this.setState({
                                globalHeartist     : globalHeartistData,
                                isHeartistLoaded   : true,
                            });
                        }

                        this.setState({
                            globalData         : previousData,
                            global             : previousData,
                            fetchingGlobalData : false,
                            fetchingData       : false,
                            globalEndOfList    : response.data.length.length < 10 ? true : false
                        });
                        
                        if(page === 1){
                            sessionStorage.setItem('global',JSON.stringify(previousData));
                            sessionStorage.setItem('globalData',JSON.stringify(previousData));
                            sessionStorage.setItem('globalHeartist',JSON.stringify(globalHeartistData));
                        }
                    }
                    this.filterCountries(this.state.globalData);
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ showGlobalError : true, fetchingData : false});  
        });
    }

    getCountryEmployeeData = async (startDate, endDate, updatePage=false) => {
        let start = moment(startDate).format("DD/MM/YYYY");
        const end = moment(endDate).format("DD/MM/YYYY");
        const {hotelCode} = this.props.location.state;
        let page =  1;
        if(updatePage){
            page = this.state.countryPage + 1;
            this.setState({countryPage : page});
        }
        
        let index = 1;
        if(page !== "1"){
            index = ((page - 1) * 10) + 1;
            this.setState({fetchingCountryData : true});
        }
        await this.getHotelDetails(startDate, endDate, hotelCode);
        const subsidiary =  this.state.hotelDetails ?  this.state.hotelDetails.subsidiary : "";
        if(subsidiary){
            
            await axios.get(`${this.getUrl().apiURL+'employee?start_date='+start+'&end_date='+end+'&page='+page}`, GLOBALAPIHEADER)
            .then(response => {
                // console.log('COUNTRY HEARTIST DATA', response)
                if (response.status === 200) {
                    if(page !== 1 && response.data.length === 0){
                        this.setState({countryEndOfList : true,
                            fetchingCountryData : false});
                    } else {
                        if(response.data && response.data.length > 0){
                            let oldCountryData = (page === 1 ? [] : this.state.country);
                            let countryData = response.data;
                            for(let i = 0; i < countryData.length; i++){ 
                                let newData = countryData[i];
                                newData.index = index++;
                                oldCountryData.push(newData); 
                            }
                            this.setState({ 
                                country             : oldCountryData,
                                countryData         : oldCountryData,
                                fetchingCountryData : false,
                                fetchingData        : false,
                                countryEndOfList    : countryData.length < 10 ? true : false
                            });
                            if(page === 1){
                                sessionStorage.setItem('countryData',JSON.stringify(oldCountryData));
                                sessionStorage.setItem('country',JSON.stringify(oldCountryData));
                            }
                        }
                    }
                } else throw new Error('Oops, something went wrong');
            }).catch(error => {
                console.error('error', error) 
                this.setState({ 
                    showGlobalError : true,
                    fetchingData    : false
                });  
            });
        }
    }
    
    handleChange = event => {
        this.setState({ searchInput: event.target.value }, () => {
            console.log('search', this.state.searchInput);
          this.hotelSearch();
        });
      };
    
    hotelSearch = () => {
        let { searchInput, data } = this.state;
        if(searchInput){
            let filteredData = data.filter(value => {
                console.log('val', value)
                console.log(value);
            return (
                (value.salesRepName && value.salesRepName.toLowerCase().includes(searchInput.toLowerCase())) ||
                searchInput.match(value.unitsSold)
              );
            });
            this.setState({ filteredData : filteredData });
        } else {
            this.setState({ filteredData : [] });
        }
        
    };

    handleCountrySearch = event => {
        this.setState({ searchInput: event.target.value }, () => {
            console.log('countrysearch', this.state.searchInput);
          this.counrtySearch();
        });
    };

    counrtySearch = () => {
        let { searchInput, countryData } = this.state;
        if(searchInput){
            let filteredData = countryData.filter(value => {
                console.log(value);
            return (
                value.vendorName.toLowerCase().includes(searchInput.toLowerCase()) ||
                searchInput.match(value.rid_code) || searchInput.match(value.unitsSold)
              );
            });
            this.setState({ countryFilteredData : filteredData });
        } else {
            this.setState({ countryFilteredData : [] });
        }        
    };

    handleCountryHeartistSearch = event => {
        this.setState({ searchInput: event.target.value }, () => {
            console.log('countryHeartistSearch', this.state.searchInput);
          this.countryHeartistSearch();
        });
    };

    countryHeartistSearch = () => {
        let { searchInput, countryHeartist } = this.state;
        if(searchInput){
            let filteredData = countryHeartist.filter(value => {
                // console.log('countryHeartistSearch - val',value);
                console.log('countryHeartistSearch - val',searchInput);
            return (
                value.salesRepName.toLowerCase().includes(searchInput.toLowerCase()) ||
                value.vendorName.toLowerCase().includes(searchInput.toLowerCase()) || searchInput.includes(value.unitsSold)
              );
            });
            this.setState({ countryHeartistFilteredData : filteredData });
        } else {
            this.setState({ countryHeartistFilteredData : [] });
        }        
    };

    handleGlobalHeartistSearch = event => {
        this.setState({ searchInput: event.target.value }, () => {
            console.log('countryHeartistSearch', this.state.searchInput);
          this.globalHeartistSearch();
        });
    };

    globalHeartistSearch = () => {
        let { searchInput, globalHeartist } = this.state;
        if(searchInput){
            let filteredData = globalHeartist.filter(value => {
                console.log('countryHeartistSearch - val',value);
            return (
                value.salesRepName.toLowerCase().includes(searchInput.toLowerCase()) || value.countryName.toLowerCase().includes(searchInput.toLowerCase()) ||
                searchInput.match(value.rid_code) || searchInput.match(value.unitsSold)
              );
            });
            this.setState({ globalHeartistFilteredData : filteredData });
        } else {
            this.setState({ globalHeartistFilteredData : [] });
        }        
    };

    handleGlobalSearch = event => {
        this.setState({ searchInput: event.target.value }, () => {
            console.log('countrysearch', this.state.searchInput);
          this.globalSearch();
        });
    };

    globalSearch = () => {
        let { searchInput, globalData } = this.state;
        if(searchInput){
            let filteredData = globalData.filter(value => {
                console.log(value);
            return (
                value.vendorName.toLowerCase().includes(searchInput.toLowerCase()) || value.countryName.toLowerCase().includes(searchInput.toLowerCase()) ||
                searchInput.match(value.rid_code));
            });
            console.log(filteredData);
            this.setState({ globalFilteredData : filteredData });
        } else {
            this.setState({ globalFilteredData : [] });
        }
        
    };

    handleFilterCountrySearch = event => {
        this.setState({ countrySearch: event.target.value }, () => {
            console.log('countrysearch', this.state.countrySearch);
          this.filterCountrySearch();
        });
    }

    filterCountrySearch = () => {
        let { countrySearch, globalData } = this.state;
        if(countrySearch === 'all'){
            this.setState({ globalFilteredData : [] });
        } else {
            let filteredData = globalData.filter(value => {
            return (
                value.countryName.toLowerCase().includes(countrySearch.toLowerCase())
              );
            });
            this.setState({ globalFilteredData : filteredData });
        }
        
    };

    handleFilterCountryHeartistSearch = event => {
        this.setState({ countryHeartistSearch: event.target.value }, () => {
          this.filterCountryHeartistSearch();
        });
    }

    filterCountryHeartistSearch = () => {
        let { countryHeartistSearch, globalHeartist } = this.state;
        if(countryHeartistSearch === 'all'){
            this.setState({ globalHeartistFilteredData : [] });
        } else {
            let filteredData = globalHeartist.filter(value => {
            return (
                value.countryName.toLowerCase().includes(countryHeartistSearch.toLowerCase())
              );
            });
            this.setState({ globalHeartistFilteredData : filteredData });
        }
        
    };

    handleStartDate = (date) => {
        this.setState({startDate: date});
    }

    handleEndDate = (date) => {
        this.setState({endDate: date});
    }

    handleClick = (e) => {
        e.preventDefault();
        console.log("Clicked Search");
        const {startDate, endDate} = this.state;
        const {hotelCode} = this.props.location.state;
        this.setState({
            fetchingData : true,
            fetchingDashboardData : true,
            employeePage : 1,
            countryPage  : 1,
            globalPage   : 1,
            dashboardData :[],
            employeeData : [],
            countryData : [],
            globalData : [],
            hotelDetails : [],
            countryHeartist : [],
            globalHeartist : [],
        });
        sessionStorage.setItem('hotelDetails',JSON.stringify([]));
        sessionStorage.setItem('dashboardData',JSON.stringify([]));
        sessionStorage.setItem('employeeData',JSON.stringify([]));
        sessionStorage.setItem('data',JSON.stringify([]));
        sessionStorage.setItem('countryData',JSON.stringify([]));
        sessionStorage.setItem('country',JSON.stringify([]));
        sessionStorage.setItem('global',JSON.stringify([]));
        sessionStorage.setItem('globalData',JSON.stringify([]));
        sessionStorage.setItem('globalHeartist',JSON.stringify([]));
        sessionStorage.setItem('countryHeartist',JSON.stringify([]));

        const fetchDashBoard = this.getDashboardData(null,true);
        const fetchEmployee = this.getEmployeeData(startDate, endDate, hotelCode);
        const fetchCountry = this.getCountryData(startDate, endDate);
        const fetchGlobal = this.getGlobalData(startDate, endDate);
        Promise.all([ fetchDashBoard, fetchEmployee, fetchCountry, fetchGlobal ]).then(() => {
            this.setState({fetchingData : false});
            this.filterCountries(this.state.globalData);
        });
    }

    getRanking = (index) => {
        switch(index) {
            case 1:
                return <img src="./images/first.png" width="35" alt="Accor Plus Logo"/>
            case 2:
                return <img src="./images/second.png" width="35" alt="Accor Plus Logo"/>
            case 3:
                return <img src="./images/third.png" width="35" alt="Accor Plus Logo"/>
            default:
                return <p>{index}</p>
        }
    }

    getMembershipBreakdown = (data) =>{
        let unique = [];
        if(data.membershipBreakdown){
            Object.entries(data.membershipBreakdown).forEach(([key, value]) => {
                unique.push(key);
             });
        }
        return unique;
    }

    globalHeartistLoadMore = () => {
        this.setState({
            globalHeartistLoad: this.state.globalHeartistLoad + 10,
            globalHeartistEndOfList: this.state.globalHeartistLoad >= this.state.globalHeartist.length
        })
    }

    countryHeartistLoadMore = () => {
        console.log('check', this.state.countryHeartistLoad )
        console.log('check', this.state.countryHeartist.length)
        console.log('check', this.state.countryHeartistLoad >= this.state.countryHeartist.length)
        this.setState({
            countryHeartistLoad: this.state.countryHeartistLoad + 10,
            countryHeartistEndOfList: this.state.countryHeartistLoad >= this.state.countryHeartist.length
        })
    }

    render() {
        const {filteredData, employeeData, countryData, countryFilteredData, countryHeartistFilteredData, globalHeartistFilteredData, globalData, globalFilteredData, dashboardData, fetchingData, countryHeartist, globalHeartist} = this.state;
        const {selected,showLeaderBoard, startDate, endDate, hotelDetails, filterCountry, fetchingDashboardData, activeDropDown} = this.state;
        const {fetchingEmployeeData, employeeEndOfList, fetchingCountryData, countryEndOfList, fetchingGlobalData, globalEndOfList, rank, previousStart, previousEnd} = this.state;
        const {hotelCode, hotelName, countryName} = this.props.location.state;
        
        const employeeDataMap = (filteredData.length > 0) ? filteredData : employeeData;
        const countryDataMap = (countryFilteredData.length > 0) ? countryFilteredData :countryData;
        const globalDataMap = (globalFilteredData.length > 0) ? globalFilteredData :globalData;

        const countryResult =  _.map(countryDataMap, item => (item.rid_code));
        const globalResult =  _.map(globalDataMap, item => (item.rid_code));

        // const key = 'salesRepName';
        // const countryHeartistDup = [...new Map(countryHeartist.map(item => [item[key], item])).values()]
        const countryHeartistMap = (countryHeartistFilteredData.length > 0) ? countryHeartistFilteredData : countryHeartist.sort((a, b) => parseInt(a.unitsSold) > parseInt(b.unitsSold) ? -1 : 1);
        // countryHeartist.sort((a, b) => parseInt(a.unitsSold) > parseInt(b.unitsSold) ? -1 : 1);
        const globalHeartistMap = (globalHeartistFilteredData.length > 0) ? globalHeartistFilteredData : globalHeartist.sort((a, b) => parseInt(a.unitsSold) > parseInt(b.unitsSold) ? -1 : 1);
        
        // const globalHeartist = ''

        const filterByCountry = filterCountry.map((item) =>
            <option value={item}>{item}</option>
        );
        const colors = ['#EC6527', '#713354', '#A51E19', '#6A8863', '#18A09F', '#557B97'];

        let pieChartData = [{title: 'No Data', value: 0, color: colors[1] }];
        let pieChart = false;
        let pieChartDataSum = 0;
        if(dashboardData.membershipBreakdown && Object.keys(dashboardData.membershipBreakdown).length > 0){
            pieChartData = [];
            pieChart = true;
            Object.keys(dashboardData.membershipBreakdown).map(function(key, index) {
                const value = parseInt(dashboardData.membershipBreakdown[key], 10);
                pieChartDataSum = pieChartDataSum + value;
                pieChartData.push({title: key, value: value, color: colors[index] });
            });
        }

        return (
            <div className="hotelSales-wrapper">
                <Header 
                    showLeaderBoard   = {showLeaderBoard}
                    hasGlobalMessage
                    hideBanner
                    goBack = {()=> this.props.history.push("/")}
                    />
                
                <div className="container leaderboard">
                    {/* <button className="btn btn-secondary mt-4" onClick={()=> this.props.history.goBack()}>
                        <FontAwesomeIcon icon={faChevronLeft} /> Back
                    </button> */}
                    <div className="row mt-4">
                        <div className="col-12 col-md-8">
                            <div className="info-box">
                                <span className="info-box-icon">
                                <svg viewBox="0 0 18 18" class="icon" width="50" height="50"><path d="M6.6 6.2h-.7c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2h.8c.1 0 .2-.1.2-.2v-1c-.1-.1-.2-.2-.3-.2zm0 3h-.7c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2h.8c.1 0 .2-.1.2-.2v-1c-.1-.1-.2-.2-.3-.2zm4.8-1.6h.8c.1 0 .2-.1.2-.2v-1c0-.1-.1-.2-.2-.2h-.8c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2zm.9 2.8v-1c0-.1-.1-.2-.2-.2h-.8c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2h.8c.2 0 .2-.1.2-.2zM9.4 6.2h-.8c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2h.8c.1 0 .2-.1.2-.2v-1c0-.1-.1-.2-.2-.2zm0 3h-.8c-.1 0-.2.1-.2.2v1c0 .1.1.2.2.2h.8c.1 0 .2-.1.2-.2v-1c0-.1-.1-.2-.2-.2zM3 15.9l-.5.6h4v-1.2H4.4c-.5 0-1 .3-1.4.6zm3.9-3v3.7h1.9v-3.9H7.1c-.1 0-.2.1-.2.2zM4.2 4.3h9.7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H4.2c-.3 0-.5.2-.5.5s.2.5.5.5zM4.6 3h8.8v-.8h.5v-.8H4.1v.8h.5V3zm6.9 11.9h2.4V4.7H4.2v10.2h2.4v-2.1c0-.3.3-.6.6-.6h3.7c.3 0 .6.3.6.6v2.1zm-.7-8.5c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1c0 .3-.3.6-.6.6h-.8c-.3 0-.6-.3-.6-.6v-1zm-3.6 4c0 .3-.2.6-.6.6h-.7c-.3 0-.6-.3-.6-.6v-1c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1zm0-3c0 .3-.2.6-.6.6h-.7c-.4 0-.6-.3-.6-.6v-1c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1zm2.8 3c0 .3-.3.6-.6.6h-.8c-.3 0-.6-.3-.6-.6v-1c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1zm0-3c0 .3-.3.6-.6.6h-.8c-.3 0-.6-.3-.6-.6v-1c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1zm1.4 3.6c-.3 0-.6-.3-.6-.6v-1c0-.3.3-.6.6-.6h.8c.3 0 .6.3.6.6v1c0 .3-.3.6-.6.6h-.8zm3.6 4.9c-.3-.4-.8-.6-1.4-.6h-2.1v1.2h4l-.5-.6zm-4.1-3.2H9.2v3.9h1.9v-3.7c0-.1-.1-.2-.2-.2z"></path></svg>
                                </span>
                                <div className="info-box-content">
                                    <span className="info-box-text"><h4>{hotelName}</h4></span>
                                    <span className="info-box-number"> RID {hotelCode}</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-4">
                            <div className="info-box">
                                <span className="info-box-icon">
                                    {/* <svg width="50" height="50" viewBox="-7 -7 102 73">
                                        <path class="icon" d="M0 7.92A7.92 7.92 0 017.92 0h72.16A7.92 7.92 0 0188 7.92v43.59a7.92 7.92 0 01-7.92 7.92H7.92A7.92 7.92 0 010 51.51V7.92z"></path><path d="M40.4 38.98h2.33l.01-.05c-1.43-.31-1.56-1.09-1.56-2.19V22.9h-3v13.38a3.39 3.39 0 00.38 2 2 2 0 001.84.7zm17.81-11.3a1.1 1.1 0 00-.4-.4 1.23 1.23 0 00-1.4.18 1.11 1.11 0 00-.34.81 1.091 1.091 0 00.34.81 1.15 1.15 0 00.83.33 1.2 1.2 0 00.57-.14 1 1 0 00.4-.4l-.34-.24a.71.71 0 01-1.283-.076.7.7 0 01-.047-.274.66.66 0 01.2-.52.66.66 0 01.5-.21.71.71 0 01.63.37l.34-.24zm-3.39-.4a1.1 1.1 0 01.4.4l-.34.24a.74.74 0 00-.907-.32.699.699 0 00-.433.68.69.69 0 00.2.51.68.68 0 00.51.21.74.74 0 00.63-.37l.34.24a1.1 1.1 0 01-.4.4 1.2 1.2 0 01-.57.14 1.13 1.13 0 01-.83-.33 1.06 1.06 0 01-.34-.81 1.07 1.07 0 01.34-.81 1.18 1.18 0 01.83-.32c.199-.001.395.047.57.14zm-3.04 1.82h-.9l-.12.29h-.49l1-2.19h.18l1 2.19h-.55l-.12-.29zm-.45-1.1l-.29.74h.58l-.29-.74zm9.73-.52a1.071 1.071 0 01.34.81 1.061 1.061 0 01-.34.81 1.16 1.16 0 01-.83.33 1.118 1.118 0 01-.82-.33 1.06 1.06 0 01-.34-.81 1.07 1.07 0 01.34-.81c.22-.21.515-.325.82-.32a1.2 1.2 0 01.83.32zm-1.33.3a.69.69 0 00-.2.51.7.7 0 00.2.52.66.66 0 00.5.21.678.678 0 00.51-.21.72.72 0 00.2-.52.69.69 0 00-.2-.51.68.68 0 00-.51-.21.66.66 0 00-.5.21zm3.5.84l.57.77h.5l-.62-.86a.65.65 0 00.39-.62.68.68 0 00-.22-.52.84.84 0 00-.57-.19h-.83v2.19h.45v-.77h.33zm.05-.4h-.38v-.63h.38a.319.319 0 01.31.195.3.3 0 01.02.125.279.279 0 01-.09.22.32.32 0 01-.24.09zm-12.56 5.56h1v.41h-1.4v-2.2h.44l-.04 1.79zm1.9.41h.44v-2.2h-.44v2.2zm3.46-2.2l-1 2.2h-.18l-1-2.2h.51l.59 1.29.55-1.33.53.04zm1.39.41h1v-.36H57v2.2h1.53v-.41h-1.06v-.55h.75v-.44h-.75v-.44zm-6.75 6.18h1v.4h-1.4v-2.19h.44l-.04 1.79zm1.9.4h.44v-2.19h-.44v2.19zm3.74-2.19v2.19h-.45v-1.17l-.55.69h-.15l-.55-.69v1.17h-.45v-2.19h.18l.89 1.15.9-1.15h.18zm1.19 2.19H58v-2.19h-.45v2.19zm3.18-1.79H60v1.79h-.45v-1.79h-.7v-.4h1.86l.02.4zm2.36 1.39h-1v-1.79h-.45v2.19h1.45v-.4zm2.37-1.39h-1v.45h.76v.38h-.76v.56h1.04v.4H64v-2.19h1.48l-.02.4zm2.44-.03a.83.83 0 00-.29-.3.86.86 0 00-.41-.11.84.84 0 00-.53.17.56.56 0 00-.2.45.498.498 0 00.14.37c.114.108.246.196.39.26l.25.11.15.07.09.08a.27.27 0 010 .12.22.22 0 01-.08.18.37.37 0 01-.23.06.66.66 0 01-.54-.32l-.31.24c.087.143.207.263.35.35a1 1 0 00.5.13.81.81 0 00.55-.18.581.581 0 00.22-.48.52.52 0 00-.13-.37 1.209 1.209 0 00-.41-.27l-.25-.11-.2-.11a.179.179 0 01-.06-.14.19.19 0 01.08-.16.39.39 0 01.2-.05.48.48 0 01.41.25l.31-.24zm2.16-.3a.92.92 0 01.29.3l-.31.24a.48.48 0 00-.42-.25.38.38 0 00-.19.05.191.191 0 00-.08.16.18.18 0 00.06.14.84.84 0 00.2.11l.25.11c.154.061.293.153.41.27a.57.57 0 01.13.37.58.58 0 01-.22.48.83.83 0 01-.55.18.93.93 0 01-.5-.13 1.059 1.059 0 01-.35-.35l.31-.24a.65.65 0 00.54.32.39.39 0 00.23-.06.22.22 0 00.08-.18.19.19 0 000-.12l-.08-.08-.16-.07-.23-.11a1.631 1.631 0 01-.4-.26.54.54 0 01-.13-.37.559.559 0 01.2-.45.81.81 0 01.52-.17.87.87 0 01.4.11zm-33.39 2.12h-3.75l-2.75-5.7c-.848.464-1.491 1.27-2.167 2.115-.52.65-1.058 1.324-1.723 1.885a8.798 8.798 0 01-2.82 1.59c-.558.188-1.13.332-1.71.43h-.25c-.02 0 0-.07.17-.14a9.68 9.68 0 001.33-.79 1.76 1.76 0 00.82-1.09 3.69 3.69 0 01-.12-3.8c.214-.423.41-.78.59-1.107.148-.267.284-.515.41-.763.283-.7.464-1.438.54-2.19.52.53 2.56 2.63 2.26 4.71a13 13 0 002.4-1.47c.125-.099.24-.198.35-.293.393-.337.722-.62 1.19-.627.35-.006.493.08.633.165.099.06.197.12.367.145a.78.78 0 00.35 0v-.07c-.248-.055-.417-.172-.586-.288-.232-.161-.464-.322-.904-.322-.569 0-.975.347-1.307.631a3.527 3.527 0 01-.313.249l-1.93-4c-.8-1.68-.56-2.89 1.21-5.29l7.71 16.02zm9.76 0h2.33l.01-.05c-1.43-.31-1.56-1.09-1.56-2.19V22.9h-3v13.38a3.39 3.39 0 00.38 2 2 2 0 001.84.7z"></path>
                                    </svg> */}
                                    <img src="/images/clients.png" width="50"></img>
                                </span>
                                <div className="info-box-content">
                                    <span className="info-box-text"><h4>Total Memberships</h4></span>
                                    <span className="info-box-number">{hotelDetails.unitsSold ?? 0}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card card-info card-outline">
                        <div className="card-body">
                            <div className="row align-items-end">
                                <div className="col-12 col-md-4 mb-2 mb-md-0">
                                    <label>Start Date</label>
                                <DatePicker
                                            className="form-control"
                                            selected={startDate}
                                            dateFormat="dd - MM - yyyy"
                                            onChange={(date) => this.handleStartDate(date)}/>
                                </div>
                                <div className="col-12 col-md-4 mb-2 mb-md-0">
                                <label>End Date</label>
                                <DatePicker
                                            className="form-control"
                                            selected={endDate} 
                                            onChange={(date) => this.handleEndDate(date)}
                                            dateFormat="dd - MM - yyyy"/>
                                </div>
                                <div className="col-12 col-md-4 mb-2 mb-md-0">
                                <button className="btn btn-sm btn-primary btn-block" onClick={this.handleClick}>
                                        <FontAwesomeIcon icon={faSearch} /> SEARCH
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-5 mb-5">
                        <Tabs defaultActiveKey="dashboard" id="uncontrolled-tab-example" className="primary-tab">
                            <Tab eventKey="dashboard" title="DASHBOARD">
                                {fetchingDashboardData && (
                                    <LoadingScreen extraClass="section-loading"/>
                                )}
                                {!fetchingDashboardData && (
                                    <div className = "row mt-4">
                                    {dashboardData && !_.isEmpty(dashboardData) &&(
                                        <React.Fragment>
                                            {/* <div className="col-md-8">
                                            </div>
                                            <div className="col-12 col-md-4 mb-3">
                                                <select className="form-control" onChange={this.handleTypeChange}>
                                                    <option value= "monthly" selected={activeDropDown === 'monthly' ? true : false}>This Month</option>
                                                    <option value="weekly" selected={activeDropDown === 'weekly' ? true : false}>This Week</option>
                                                </select>
                                            </div> */}
                                            <div className="col-4">
                                                <div className="card rankingTile">
                                                    <div className="card-body text-center">
                                                        <h6 className="font-weight-bolder text-dark">Sales</h6>
                                                        <h1 className="d-inline"> {dashboardData.sales['total'] ?? 0 }</h1>
                                                        {rank && rank.sales !== 0 &&  (
                                                            <React.Fragment>
                                                                {rank.salesUp && (
                                                                    <div className="info-tooltip font-weight-bold rank rank-up">
                                                                        <FontAwesomeIcon icon={faSortUp}/>
                                                                    {Math.abs(rank.sales)}<span className="tooltiptext">This hotel has sold {Math.abs(rank.sales)} more memberships than {previousStart} - {previousEnd}.</span>
                                                                    </div>    
                                                                )}
                                                                {!rank.salesUp &&  (
                                                                    <div className="info-tooltip font-weight-bold rank rank-down">
                                                                        <FontAwesomeIcon icon={faSortDown}/>
                                                                        {Math.abs(rank.sales)}<span className="tooltiptext">This hotel has sold {Math.abs(rank.sales)} less memberships than {previousStart} - {previousEnd}.</span>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="card rankingTile">
                                                    <div className="card-body text-center">
                                                        <h6 className="font-weight-bolder text-dark">{countryName ?? 'Country'} Rank</h6>
                                                        <h1 className="d-inline">{dashboardData.countryRank['rank'] !== '' ? dashboardData.countryRank['rank'] : 'N/A'} </h1>
                                                        {rank && rank.countryRank !== 0 && (
                                                            <React.Fragment>
                                                                {rank.countryRankUp &&(
                                                                    <div className="info-tooltip font-weight-bold rank rank-up">
                                                                        <FontAwesomeIcon icon={faSortUp}/>
                                                                        {Math.abs(rank.countryRank)}
                                                                        <span className="tooltiptext">
                                                                            This hotel has increased its rank compared to {previousStart} - {previousEnd}.
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                {!rank.countryRankUp && (
                                                                    <div className="info-tooltip font-weight-bold rank rank-down">
                                                                        <FontAwesomeIcon icon={faSortDown}/>
                                                                        {Math.abs(rank.countryRank)}
                                                                        <span className="tooltiptext">
                                                                            This hotel has reduced its rank compared to {previousStart} - {previousEnd}.
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="card rankingTile">
                                                    <div className="card-body text-center">
                                                        <h6 className="font-weight-bolder text-dark">Global Rank</h6>
                                                        <h1 className="d-inline">{dashboardData.globalRank['rank'] !== '' ? dashboardData.globalRank['rank'] : 'N/A'} </h1>
                                                        {rank && rank.globalRank !== 0 && (
                                                            <React.Fragment>
                                                                {rank.globalRankUp && (
                                                                    <div className="info-tooltip font-weight-bold rank rank-up">
                                                                        <FontAwesomeIcon icon={faSortUp}/>
                                                                        {Math.abs(rank.globalRank)}
                                                                        <span className="tooltiptext">
                                                                            This hotel has increased its rank compared to {previousStart} - {previousEnd}.
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                    {!rank.globalRankUp && (
                                                                     <div className="info-tooltip font-weight-bold rank rank-down">
                                                                        <FontAwesomeIcon icon={faSortDown}/>
                                                                        {Math.abs(rank.globalRank)}
                                                                        <span className="tooltiptext">
                                                                            This hotel has gone its rank compared to {previousStart} - {previousEnd}.
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h3 className="card-title font-weight-bold d-block">{hotelCode} - Membership Breakdown</h3>
                                                    </div>
                                                    <div className="card-body">
                                                        {pieChart && (
                                                            <PieChart
                                                                animation
                                                                animationDuration={500}
                                                                animationEasing="ease-out"
                                                                center={[50, 50]}
                                                                data={pieChartData}
                                                                radius={PieChart.defaultProps.radius - 6}
                                                                lineWidth={60}
                                                                viewBoxSize={[100, 100]}
                                                                segmentsStyle={{ transition: 'stroke .3s', cursor: 'pointer' }}
                                                                segmentsShift={(index) => (index === selected ? 6 : 1)}
                                                                animate
                                                                label={({ dataEntry }) => dataEntry.value}
                                                                labelPosition={100 - 60 / 2}
                                                                labelStyle={{
                                                                    fill: '#fff',
                                                                    opacity: 0.75,
                                                                    pointerEvents: 'none',
                                                                    fontSize:'0.75rem',
                                                                    fontWeight:'700'
                                                                }}
                                                                totalValue={pieChartDataSum}
                                                                onClick={(_, index) => {
                                                                    this.setState({selected : index === selected ? undefined : index});
                                                                }}/>
                                                        )}
                                                    </div>
                                                    <div className="card-footer">
                                                        <ul className="chart-legend clearfix">
                                                            {pieChartData.length > 0 && pieChartData.map((item, index) =>
                                                                <li> <FontAwesomeIcon icon={faSquare} color={item.color} /> {item.title} - {item.value}  </li>
                                                            )}
                                                        </ul>   
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-8">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <h3 className="card-title font-weight-bold"><FontAwesomeIcon icon={faListOl}/> Top 5 Hotels in {countryName ?? 'your Country'}</h3>
                                                    </div>
                                                    <div className="card-body p-0">
                                                        <Accordion>
                                                            <div className="row mt-4 mb-2 mx-0 leaderboardTable-head">
                                                                <div className="col-2 text-center">#</div>
                                                                <div className="mb-0 col-6">Hotel</div>
                                                                <div className="mb-0 col-3 text-center">Total</div>
                                                                <div className="mb-0 col-1"></div>  
                                                            </div>
                                                            {dashboardData.topHotels && dashboardData.topHotels.map((item, index) =>
                                                                <Card key={index} className={hotelCode === item.rid_code ? 'leaderboardTable-body active' : 'leaderboardTable-body'}>
                                                                    <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                                        <div className="d-flex font-weight-bold">
                                                                            <div className="mb-0 col-2 text-center">
                                                                                {this.getRanking(index+1)}
                                                                            </div>
                                                                            <div className="mb-0 col-6">
                                                                                    <p className="mb-1 font-weight-bold">{item.vendorName}</p> 
                                                                                    <p className="mb-0">RID {item.rid_code}</p>
                                                                            </div>
                                                                            <div className="mb-0 col-3 text-center">
                                                                                {item.unitsSold}
                                                                            </div>
                                                                            <div className="mb-0 col-1">
                                                                                <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                            </div>   
                                                                        </div>
                                                                    </Accordion.Toggle>
                                                                    <Accordion.Collapse eventKey={index+1}>
                                                                        <Card.Body>
                                                                            <div className="d-flex">
                                                                                <div className="col-2"></div>
                                                                                <div className="col-10">
                                                                                {this.getMembershipBreakdown(item).map((element) => 
                                                                                    <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                                )}
                                                                                </div>
                                                                            </div>
                                                                        </Card.Body>
                                                                    </Accordion.Collapse>
                                                                </Card>
                                                            )}
                                                            {dashboardData.topHotels && dashboardData.topHotels.length === 0  && (
                                                                <div className="font-weight-bold text-center mt-4">
                                                                    <p><FontAwesomeIcon icon={faExclamation}/> No Data Found! Contact your AccorPlus Ambassador</p>
                                                            </div> 
                                                            )}
                                                        </Accordion>
                                                    </div>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )}
                                    {dashboardData.length === 0 && (
                                        <div className="col-12 font-weight-bold text-center">
                                            <p><FontAwesomeIcon icon={faExclamation}/> No Data Found! Contact your AccorPlus Ambassador</p>
                                        </div> 
                                    )}
                                </div>
                                )}
                            </Tab>
                            <Tab eventKey="hotel" title="HOTEL">
                                {fetchingData && (
                                    <LoadingScreen extraClass="section-loading"/>
                                )}
                                {!fetchingData && employeeDataMap.length > 0 && (
                                    <React.Fragment>
                                        <div className = "row mt-4">
                                            <div className="col-md-8"></div>
                                            <div className="col-12 col-md-4 input-group">
                                                <input type="text" placeholder="Search" className="form-control" onChange={this.handleChange}></input>
                                                <div className="input-group-append">
                                                    <div className="input-group-text">
                                                            <FontAwesomeIcon icon={faSearch} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Accordion>
                                            <div className="row mt-4 mb-2 leaderboardTable-head">
                                                <div className="col-2 text-center">#</div>
                                                <div className="mb-0 col-6">Heartist</div>
                                                <div className="mb-0 col-3 text-center"> Total</div>
                                                <div className="mb-0 col-1"></div>  
                                            </div>
                                            {employeeDataMap.map((item, index) =>
                                                <Card key={index} className="leaderboardTable-body">
                                                    <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                        <div className="d-flex font-weight-bold">
                                                            <div className="mb-0 col-2 text-center">
                                                                {this.getRanking(item.index)}
                                                            </div>
                                                            <div className="mb-0 col-6" style={{textTransform: 'capitalize'}}>
                                                                {/* Heartist{item.index} */}
                                                                {item.salesRepName}
                                                            </div>
                                                            <div className="mb-0 col-3 text-center">
                                                                {item.unitsSold}
                                                            </div>
                                                            <div className="mb-0 col-1">
                                                                <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                            </div>   
                                                        </div>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey={index+1}>
                                                        <Card.Body>
                                                            <div className="d-flex">
                                                                <div className="col-2"></div>
                                                                <div className="col-10">
                                                                {this.getMembershipBreakdown(item).map((element) => 
                                                                    <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                )}
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            )}
                                        </Accordion>
                                        <div className="font-weight-bold text-center mt-4">
                                            {fetchingEmployeeData && <p>Loading ...</p>}
                                            {employeeEndOfList && <p><FontAwesomeIcon icon={faExclamation} color="#ec6527"/> End of List</p>}
                                            {!employeeEndOfList && !fetchingEmployeeData && <button className="btn btn-secondary" onClick={ ()=>this.getEmployeeData(startDate, endDate, hotelCode, true)}> Load More <FontAwesomeIcon icon={faChevronRight}/></button>}
                                        </div> 
                                    </React.Fragment>
                                )}
                                {!fetchingData && employeeDataMap.length === 0 && (
                                    <div className="font-weight-bold text-center mt-4">
                                        <p><FontAwesomeIcon icon={faExclamation}/> No Data Found! Contact your AccorPlus Ambassador</p>
                                    </div> 
                                )}
                            </Tab>
                            <Tab eventKey="country" title={countryName ?? 'COUNTRY'} >
                                <div className='innerTab mt-3'>                                    
                                    <Tabs defaultActiveKey="hotelList" id="hotelList-tab" className="secondary-tab"> 
                                        <Tab eventKey="hotelList" title="Hotel">
                                            {fetchingData && (
                                                <LoadingScreen extraClass="section-loading"/>
                                            )}
                                            {!fetchingData && countryDataMap.length > 0 && (
                                                <React.Fragment>
                                                    <div className ="row mt-4">
                                                    <div className="col-8">

                                                    </div>
                                                    <div className="col-12 col-md-4 input-group">
                                                        <input type="text" placeholder="Search" className="form-control" onChange={this.handleCountrySearch}></input>
                                                        <div className="input-group-append">
                                                            <div className="input-group-text">
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                    <Accordion>
                                                        <div className="row mt-4 mb-2 leaderboardTable-head">
                                                            <div className="col-1 text-center">#</div>
                                                            <div className="mb-0 col-7">
                                                                Hotel
                                                            </div>
                                                            <div className="mb-0 col-3 text-center">
                                                                Total
                                                            </div>
                                                            <div className="mb-0 col-1">
                                                            </div>  
                                                        </div>
                                                        {countryDataMap.map((item, index) =>
                                                            <Card key={index} className={hotelCode === item.rid_code ? 'leaderboardTable-body active' : 'leaderboardTable-body'}>
                                                                <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                                    <div className="d-flex">
                                                                        <div className="mb-0 col-1 text-center font-weight-bold">
                                                                            {this.getRanking(item.index)}
                                                                        </div>
                                                                        <div className="mb-0 col-7">
                                                                            <p className="mb-1 font-weight-bold">{item.vendorName}</p> 
                                                                            <p className="mb-0">RID {item.rid_code}</p>
                                                                        </div>
                                                                        <div className="mb-0 col-3 text-center font-weight-bold">
                                                                            {item.unitsSold}
                                                                        </div>
                                                                        <div className="mb-0 col-1">
                                                                            <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                        </div>   
                                                                    </div>
                                                                </Accordion.Toggle>
                                                                <Accordion.Collapse eventKey={index+1}>
                                                                    <Card.Body>
                                                                        <div className="d-flex">
                                                                            <div className="col-1"></div>
                                                                            <div className="col-11">
                                                                                {this.getMembershipBreakdown(item).map((element) => 
                                                                                    <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> 
                                                        )}
                                                        {!countryResult.includes(hotelCode) && dashboardData.countryRank && (
                                                            <Card key={dashboardData.countryRank['rank']} className='leaderboardTable-body active'>
                                                            <Accordion.Toggle as={Card.Header} eventKey={dashboardData.countryRank['rank']}>
                                                                <div className="d-flex">
                                                                    <div className="mb-0 col-1 text-center font-weight-bold">
                                                                        {dashboardData.countryRank['rank'] !== '' ? dashboardData.countryRank['rank'] : 'N/A'}
                                                                    </div>
                                                                    <div className="mb-0 col-7">
                                                                        <p className="mb-1 font-weight-bold">{hotelDetails.vendorName}</p> 
                                                                        <p className="mb-0">RID {hotelCode}</p>
                                                                    </div>
                                                                    <div className="mb-0 col-3 text-center font-weight-bold">
                                                                        {dashboardData.sales['total'] ?? 'N/A'}
                                                                    </div>
                                                                    <div className="mb-0 col-1">
                                                                        <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                    </div>   
                                                                </div>
                                                            </Accordion.Toggle>
                                                            <Accordion.Collapse eventKey={dashboardData.countryRank['rank']}>
                                                                <Card.Body>
                                                                    <div className="d-flex">
                                                                        <div className="col-1"></div>
                                                                        <div className="col-11">
                                                                            {this.getMembershipBreakdown(dashboardData).map((element) => 
                                                                                <p className="mb-0">{element} : {dashboardData.membershipBreakdown[element]}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card> 
                                                        )}
                                                    </Accordion>
                                                    <div className="font-weight-bold text-center mt-4">
                                                        {fetchingCountryData && <p>Loading ...</p>}
                                                        {countryEndOfList && <p><FontAwesomeIcon icon={faExclamation} color="#ec6527"/> End of List</p>}
                                                        {!countryEndOfList && !fetchingCountryData && <button className="btn btn-secondary" onClick={ ()=> this.getCountryData(startDate, endDate, true)}> Load More <FontAwesomeIcon icon={faChevronRight}/></button>}
                                                    </div> 
                                                </React.Fragment>
                                            )}
                                            {!fetchingData && countryDataMap.length === 0 && countryEndOfList && (
                                                <div className="font-weight-bold text-center mt-4">
                                                    <p><FontAwesomeIcon icon={faExclamation}/> No Sales Found </p>
                                                </div> 
                                            )}
                                            {!fetchingData && countryDataMap.length === 0 && !countryEndOfList && (
                                                <div className="font-weight-bold text-center mt-4">
                                                    <p><FontAwesomeIcon icon={faExclamation}/> No Data Found! Contact your AccorPlus Ambassador</p>
                                                </div>
                                            )}
                                        </Tab>
                                        <Tab eventKey="employeeList" title="Heartist">
                                            <React.Fragment>
                                                <div className = "row mt-4">
                                                    <div className="col-md-8"></div>
                                                    <div className="col-12 col-md-4 input-group">
                                                        <input type="text" placeholder="Search" className="form-control" onChange={this.handleCountryHeartistSearch}></input>
                                                        <div className="input-group-append">
                                                            <div className="input-group-text">
                                                                    <FontAwesomeIcon icon={faSearch} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <Accordion>
                                                    <div className="row mt-4 mb-2 leaderboardTable-head">
                                                        <div className="col-1 text-center">#</div>
                                                        <div className="mb-0 col-4">Heartist</div>
                                                        <div className="mb-0 col-3">Hotel</div>
                                                        <div className="mb-0 col-3 text-center"> Total</div>
                                                        <div className="mb-0 col-1"></div>  
                                                    </div>
                                                    {fetchingData && (
                                                        <LoadingScreen extraClass="section-loading"/>
                                                    )}
                                                    {countryHeartistMap?.slice(0, this.state.countryHeartistLoad)?.map((item, index) =>
                                                        <Card key={index} className="leaderboardTable-body">
                                                            <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                                <div className="d-flex font-weight-bold">
                                                                    <div className="mb-0 col-1 text-center">
                                                                        {/* {this.getRanking(item.index)} */}
                                                                        {this.getRanking(index + 1)}
                                                                    </div>
                                                                    <div className="mb-0 col-4" style={{textTransform: 'capitalize'}}>
                                                                        {/* Heartist{item.index} */}
                                                                        {item.salesRepName}
                                                                    </div>
                                                                    <div className="mb-0 col-3" style={{textTransform: 'capitalize'}}>
                                                                        {/* Heartist{item.index} */}
                                                                        {item.vendorName}
                                                                    </div>
                                                                    <div className="mb-0 col-3 text-center">
                                                                        {item.unitsSold}
                                                                    </div>
                                                                    <div className="mb-0 col-1">
                                                                        <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                    </div>   
                                                                </div>
                                                            </Accordion.Toggle>
                                                            <Accordion.Collapse eventKey={index+1}>
                                                                <Card.Body>
                                                                    <div className="d-flex">
                                                                        <div className="col-1"></div>
                                                                        <div className="col-10">
                                                                        {this.getMembershipBreakdown(item).map((element) => 
                                                                            <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                        )}
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card>
                                                    )}
                                                </Accordion>
                                                <div className="font-weight-bold text-center mt-4">                                                   
                                                    {this.state.fetchingCountryHeartistData && <p>Loading ...</p>}
                                                    {this.state.countryHeartistEndOfList && <p><FontAwesomeIcon icon={faExclamation} color="#ec6527"/> End of List</p>}
                                                    {/* !this.state.countryHeartistEndOfList && !fetchingCountryData &&  */}
                                                    {!this.state.countryHeartistEndOfList && !this.state.fetchingCountryHeartistData && <button className="btn btn-secondary" onClick={ ()=>this.countryHeartistLoadMore()}> Load More <FontAwesomeIcon icon={faChevronRight}/></button>}
                                                </div> 
                                            </React.Fragment>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Tab>
                            <Tab eventKey="global" title="GLOBAL">
                                <div className='innerTab mt-3'>                                    
                                    <Tabs defaultActiveKey="globalList" id="globalList-tab" className="secondary-tab">
                                        <Tab className='mr-2' eventKey="globalList" title="Hotel">
                                            {fetchingData && (
                                                <LoadingScreen extraClass="section-loading"/>
                                            )}
                                            {!fetchingData && globalDataMap.length > 0 && (
                                                <React.Fragment>
                                                    <div className ="row mt-4">
                                                        <div className="col-12 col-md-4">
                                                            <select className="form-control mb-4 mb-md-0" onChange={this.handleFilterCountrySearch}>
                                                            <option value="all" selected>ALL COUNTRIES</option>
                                                                {filterByCountry}
                                                            </select>
                                                        </div>
                                                        <div className="col-md-4">

                                                        </div>
                                                        <div className="col-12 col-md-4 input-group">
                                                            <input type="text" placeholder="Search" className="form-control" onChange={this.handleGlobalSearch}></input>
                                                            <div className="input-group-append">
                                                                <div className="input-group-text">
                                                                        <FontAwesomeIcon icon={faSearch} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <Accordion>
                                                        <div className="row mt-4 mb-2 leaderboardTable-head">
                                                            <div className="col-1 text-center">#</div>
                                                            <div className="mb-0 col-6">
                                                                Hotel
                                                            </div>
                                                            <div className="mb-0 col-2">
                                                                Country
                                                            </div>
                                                            <div className="mb-0 col-2 text-center">
                                                                Total
                                                            </div>
                                                            <div className="mb-0 col-1">
                                                            </div>  
                                                        </div>                                                        
                                                        {globalDataMap.map((item, index) =>
                                                            <Card key={index} className={hotelCode === item.rid_code ? 'leaderboardTable-body active' : 'leaderboardTable-body'}>
                                                                <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                                    <div className="d-flex">
                                                                        <div className="mb-0 col-1 text-center font-weight-bold">
                                                                            {this.getRanking(item.index)}
                                                                        </div>
                                                                        <div className="mb-0 col-6">
                                                                            <p className="mb-1 font-weight-bold">{item.vendorName}</p> 
                                                                            <p className="mb-0">RID {item.rid_code}</p>
                                                                        </div>
                                                                        <div className="mb-0 col-2 font-weight-bold">
                                                                            {item.countryName}
                                                                        </div>
                                                                        <div className="mb-0 col-2 text-center font-weight-bold">
                                                                            {item.unitsSold}
                                                                        </div>
                                                                        <div className="mb-0 col-1 font-weight-bold">
                                                                            <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                        </div>   
                                                                    </div>
                                                                </Accordion.Toggle>
                                                                <Accordion.Collapse eventKey={index+1}>
                                                                    <Card.Body>
                                                                        <div className="d-flex">
                                                                            <div className="col-1"></div>
                                                                            <div className="col-11">
                                                                                {this.getMembershipBreakdown(item).map((element) => 
                                                                                    <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </Card.Body>
                                                                </Accordion.Collapse>
                                                            </Card> 
                                                        )}
                                                        {!globalResult.includes(hotelCode) && dashboardData && dashboardData.globalRank &&(
                                                            <Card key={dashboardData.globalRank['rank']} className='leaderboardTable-body active'>
                                                            <Accordion.Toggle as={Card.Header} eventKey={dashboardData.globalRank['rank']}>
                                                                <div className="d-flex">
                                                                    <div className="mb-0 col-1 text-center font-weight-bold">
                                                                        {dashboardData.globalRank['rank'] !== '' ? dashboardData.globalRank['rank'] : 'N/A'}
                                                                    </div>
                                                                    <div className="mb-0 col-6">
                                                                        <p className="mb-1 font-weight-bold">{hotelDetails.vendorName}</p> 
                                                                        <p className="mb-0">RID {hotelCode}</p>
                                                                    </div>
                                                                    <div className="mb-0 col-2 font-weight-bold text-capitalize">
                                                                            {/* {countryName.toLowerCase()} */}
                                                                        </div>
                                                                    <div className="mb-0 col-2 text-center font-weight-bold">
                                                                        {dashboardData.sales['total'] ?? 'N/A'}
                                                                    </div>
                                                                    <div className="mb-0 col-1">
                                                                        <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                                    </div>   
                                                                </div>
                                                            </Accordion.Toggle>
                                                            <Accordion.Collapse eventKey={dashboardData.globalRank['rank']}>
                                                                <Card.Body>
                                                                    <div className="d-flex">
                                                                        <div className="col-1"></div>
                                                                        <div className="col-11">
                                                                            {this.getMembershipBreakdown(dashboardData).map((element) => 
                                                                                <p className="mb-0">{element} : {dashboardData.membershipBreakdown[element]}</p>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </Card.Body>
                                                            </Accordion.Collapse>
                                                        </Card> 
                                                        )}
                                                    </Accordion>
                                                    <div className="font-weight-bold text-center mt-4">
                                                        {fetchingGlobalData && <p>Loading ...</p>}
                                                        {globalEndOfList && <p><FontAwesomeIcon icon={faExclamation} color="#ec6527"/> End of List <FontAwesomeIcon icon={faExclamation} color="#ec6527"/></p>}
                                                        {!globalEndOfList && !fetchingGlobalData && <button className="btn btn-secondary" onClick={ ()=> this.getGlobalData(startDate, endDate, true)}> Load More <FontAwesomeIcon icon={faChevronRight}/></button>}
                                                    </div> 

                                                </React.Fragment>
                                            )}
                                            {!fetchingData && globalDataMap.length === 0 && !globalEndOfList && (
                                                <div className="col-12 font-weight-bold text-center mt-2">
                                                    <p><FontAwesomeIcon icon={faExclamation}/> No Data Found! Contact your AccorPlus Ambassador</p>
                                                </div>
                                            )}
                                        </Tab>
                                        <Tab eventKey="globalEmployeeList" title="Heartist">
                                            <div className = "row mt-4">
                                                <div className="col-12 col-md-4">
                                                    <select className="form-control mb-4 mb-md-0" onChange={this.handleFilterCountryHeartistSearch}>
                                                    <option value="all" selected>ALL COUNTRIES</option>
                                                        {filterByCountry}
                                                    </select>
                                                </div>
                                                <div className="col-md-4"></div>
                                                <div className="col-12 col-md-4 input-group">
                                                    <input type="text" placeholder="Search" className="form-control" onChange={this.handleGlobalHeartistSearch}></input>
                                                    <div className="input-group-append">
                                                        <div className="input-group-text">
                                                                <FontAwesomeIcon icon={faSearch} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Accordion>                                        
                                            <div className="row mt-4 mb-2 leaderboardTable-head">
                                                <div className="col-1 text-center">#</div>
                                                <div className="mb-0 col-4">Heartist</div>
                                                <div className="mb-0 col-3">Country</div>
                                                <div className="mb-0 col-3 text-center"> Total</div>
                                                <div className="mb-0 col-1"></div>                                                  
                                            </div>
                                            {fetchingData && (
                                                <LoadingScreen extraClass="section-loading"/>
                                            )}
                                            {globalHeartistMap?.slice(0, this.state.globalHeartistLoad)?.map((item, index) =>
                                                <Card key={index} className="leaderboardTable-body">
                                                    <Accordion.Toggle as={Card.Header} eventKey={index+1}>
                                                        <div className="d-flex font-weight-bold">
                                                            <div className="mb-0 col-1 text-center">
                                                                {/* {this.getRanking(item.index)} */}
                                                                {this.getRanking(index + 1)}
                                                            </div>
                                                            <div className="mb-0 col-4" style={{textTransform: 'capitalize'}}>
                                                                {/* Heartist{item.index} */}
                                                                {item.salesRepName}
                                                                <p className="mb-0">RID {item.rid_code}</p>
                                                            </div>
                                                            <div className="mb-0 col-3" style={{textTransform: 'capitalize'}}>
                                                                {/* Heartist{item.index} */}
                                                                {/* {item.rid_code} */}
                                                                {item.countryName}
                                                            </div>
                                                            <div className="mb-0 col-3 text-center">
                                                                {item.unitsSold}
                                                            </div>
                                                            <div className="mb-0 col-1">
                                                                <button className="btn btn-sm btn-primary"><FontAwesomeIcon icon={faPlus}/></button>
                                                            </div>   
                                                        </div>
                                                    </Accordion.Toggle>
                                                    <Accordion.Collapse eventKey={index+1}>
                                                        <Card.Body>
                                                            <div className="d-flex">
                                                                <div className="col-1"></div>
                                                                <div className="col-11">
                                                                {this.getMembershipBreakdown(item).map((element) => 
                                                                    <p className="mb-0">{element} : {item.membershipBreakdown[element]}</p>
                                                                )}
                                                                </div>
                                                            </div>
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            )}
                                            </Accordion>
                                            <div className="font-weight-bold text-center mt-4">
                                                {/* {fetchingEmployeeData && <p>Loading ...</p>} */}
                                                {this.state.globalHeartistEndOfList && <p><FontAwesomeIcon icon={faExclamation} color="#ec6527"/> End of List</p>}
                                                {!this.state.globalHeartistEndOfList && !fetchingGlobalData && <button className="btn btn-secondary" onClick={ ()=>this.globalHeartistLoadMore()}> Load More <FontAwesomeIcon icon={faChevronRight}/></button>}
                                            </div>                                             
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
        </div>
        );
    }
}

export default (LeaderBoard);
